import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterByOption } from './filter-by-options.enum';

@Component({
  selector: 'fgbcl-filter-by',
  templateUrl: './filter-by.component.html',
  styleUrls: ['./filter-by.component.scss'],
})
export class FilterByComponent implements OnInit {
  selectedOption: any;
  @Input() arrayToFilter: any[];
  @Input() filterOptions: FilterByOption;
  @Output() filteredArray = new EventEmitter<any[]>();

  constructor() {}

  ngOnInit(): void {}

  /*
   Filter the array by property or sub-property if defined.
  */
  filterByProperty(value: string): void {
    this.selectedOption = value;

    let newArray: any[];
    if (this.filterOptions.subPropertyToFilter) {
      newArray = this.filterByNestedProperty(value);
    } else {
      newArray = this.arrayToFilter.filter(
        (item) => item[this.filterOptions.propertyToFilter].toLowerCase() == value.toLowerCase()
      );
    }

    this.filteredArray.emit(newArray);
  }

  /*
   Filter the array by sub-property from property object. Returns false if the expected property object is empty.
  */
  filterByNestedProperty(value: string): any[] {
    return this.arrayToFilter.filter((properties) => {
      if (properties[this.filterOptions.propertyToFilter]) {
        return properties[this.filterOptions.propertyToFilter].find(
          (child: any) => child[this.filterOptions.subPropertyToFilter!].toLowerCase() == value.toLowerCase()
        );
      } else {
        return false;
      }
    });
  }

  /*
   Resets the filter to the original array
  */
  resetFilter(): void {
    this.selectedOption = undefined;
    this.filteredArray.emit(this.arrayToFilter);
  }
}
